<div fxLayout="column" fxLayoutAlign="center center">

  <mat-card appearance="outlined" *ngIf="!!boardThread" class="board-comment-card">
    <mat-card-title-group>
      <mat-card-title>
        <div *ngIf="boardThread.thread_owner===owner_email">
          <button mat-mini-fab color="primary" (click)="openThreadBrowseDialog()">{{ boardThread.thread_owner | slice:
            0:3 }} </button>&nbsp;{{boardThread.thread_name}}
        </div>
        <div *ngIf="boardThread.thread_owner!==owner_email">
          <button mat-mini-fab color="accent" (click)="openThreadBrowseDialog()">{{ boardThread.thread_owner | slice:
            0:3 }} </button>&nbsp;{{boardThread.thread_name}}
        </div>
      </mat-card-title>
      <mat-card-subtitle [style.overflow]="'auto'" [style.height.px]="'110'"
        style="white-space: pre-wrap">{{boardThread.thread_desc}}</mat-card-subtitle>
      <img mat-card-lg-image *ngIf="!!boardThread.thread_image" [src]="boardThread.thread_image.download_url">
    </mat-card-title-group>
  </mat-card>

</div>

  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="filter-field">
      <mat-form-field fxFlex="25%">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
      </mat-form-field>
    </div>
    <div class="middle-button" fxLayoutGap="10px">
      <button mat-raised-button color="primary" (click)="openAddDialog()">
        <mat-icon>add</mat-icon>
        <span>{{'コメント' | translate}}</span>
      </button>
    </div>
</div>

<div fxLayout="column" fxLayoutAlign="center center">

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="comment_owner" >
      <th mat-header-cell mat-sort-header *matHeaderCellDef  style="text-align:left" [style.width.px]="89"> {{'投稿者' | translate}} </th>
      <td mat-cell *matCellDef="let boardComment" style="text-align:left" [style.width.px]="65" [style.min-width.px]="65">
        <div *ngIf="boardComment.comment_owner===owner_email">
          <button mat-mini-fab color="primary" (click)="openEditDialog(boardComment)">{{ boardComment.comment_owner |
            slice: 0:3 }} </button>
        </div>
        <div *ngIf="boardComment.comment_owner!==owner_email">
          <button mat-mini-fab color="accent" (click)="openBrowseDialog(boardComment)">{{ boardComment.comment_owner |
            slice: 0:3 }} </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="created">
      <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align:left" [style.width.px]="85">
        {{'投稿日時' | translate}} </th>
      <td mat-cell *matCellDef="let boardComment" style="text-align:left" [style.width.px]="85"
        [style.min-width.px]="85">
        {{ boardComment.created.toDate() | date: 'yyyy/MM/dd' }}<br>
        {{ boardComment.created.toDate() | date: 'HH:mm:ss' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="comment_desc">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.min-width.px]="300"> {{'コメント' | translate}} </th>
      <td mat-cell *matCellDef="let boardComment" style="white-space: pre-wrap">
        {{ boardComment.comment_desc }}
      </td>
    </ng-container>

    <ng-container matColumnDef="comment_image">
      <th mat-header-cell *matHeaderCellDef style="text-align:left" [style.width.px]="124"> {{'画像' | translate}} </th>
      <td mat-cell *matCellDef="let boardComment" style="text-align:left" [style.width.px]="100" [style.min-width.px]="100">
        <img *ngIf="!!boardComment.comment_image" [src]="boardComment.comment_image.download_url" height="70px" width="auto">
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>